
export default {
    props: {
        dashboardStatuses: {
            type: Object,
            default: {}
        }
    },
}
